var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import * as Styled from './Icon.styled';
var iconsMap = {
    'logo-mark': '\\E000',
    'logo-type': '\\E001',
    logo: '\\E002',
    'happiness-guarantee': '\\E003',
    'one-purchased-one-donated': '\\E004',
    'motion-lines': '\\E005',
    pinterest: '\\E100',
    tumblr: '\\E101',
    twitter: '\\E102',
    youtube: '\\E103',
    spotify: '\\E104',
    instagram: '\\E105',
    facebook: '\\E106',
    'b-corp': '\\E107',
    'over-the-calf': '\\E200',
    'over-the-calf-filled': '\\E201',
    'knee-high': '\\E200',
    'knee-high-filled': '\\E201',
    calf: '\\E202',
    'calf-filled': '\\E203',
    quarter: '\\E204',
    'quarter-filled': '\\E205',
    ankle: '\\E206',
    'ankle-filled': '\\E207',
    'no-show': '\\E208',
    'no-show-filled': '\\E209',
    't-shirt': '\\E210',
    't-shirt-filled': '\\E211',
    tank: '\\E212',
    'tank-filled': '\\E213',
    'womens-underwear': '\\E214',
    'womens-underwear-filled': '\\E215',
    'mens-underwear': '\\E216',
    'mens-underwear-filled': '\\E217',
    close: '\\F000',
    plus: '\\F001',
    minus: '\\F002',
    'chevron-up': '\\F003',
    'chevron-right': '\\F004',
    'chevron-down': '\\F005',
    'chevron-left': '\\F006',
    'arrow-up': '\\F007',
    'arrow-right': '\\F008',
    'arrow-down': '\\F009',
    'arrow-left': '\\F00A',
    burger: '\\F00B',
    search: '\\F00C',
    cart: '\\F00D',
    account: '\\F00E',
    shipping: '\\F00F',
    'size-guide': '\\F010',
    filter: '\\F011',
    'checkbox-active': '\\F012',
    'checkbox-default': '\\F013',
    'checkbox-disabled': '\\F014',
    check: '\\F015',
    heart: '\\F016',
    'heart-filled': '\\F017',
    trash: '\\F018',
    show: '\\F019',
    hide: '\\F020',
    tag: '\\F021',
    'quick-add': '\\F022',
    bag: '\\F023',
    'question-mark': '\\F024',
    swipe: '\\F025',
    calendar: '\\F036',
    sms: '\\F028'
};
var iconNames = Object.keys(iconsMap);
/**
 * A component that renders an icon from our icon font pack
 * Accepts three different styles (outline, solid, and ghost),
 * and different sizes (mini, regular, mega, inherit, or a number)
 */
var Icon = function (_a) {
    var _b = _a.colorMode, colorMode = _b === void 0 ? 'inherit' : _b, name = _a.name, _c = _a.variant, variant = _c === void 0 ? 'inherit' : _c, _d = _a.size, size = _d === void 0 ? 'inherit' : _d, rest = __rest(_a, ["colorMode", "name", "variant", "size"]);
    if (!iconsMap[name])
        return React.createElement("span", null, "\u2612");
    if (size === 'inherit')
        return (React.createElement(Styled.Icon, __assign({ colorMode: colorMode, icon: iconsMap[name], size: size, variant: variant }, rest)));
    return (React.createElement(Styled.IconContainer, { size: size, variant: variant, colorMode: colorMode },
        React.createElement(Styled.Icon, __assign({ colorMode: colorMode, icon: iconsMap[name], size: size, variant: variant }, rest))));
};
export { iconNames };
export default Icon;
